var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 128,
    viewBox: "0 0 168 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5334 79.643C12.5334 79.643 22.5766 71.1402 26.5706 71.5877C35.5862 72.6092 70.0975 95.9286 76.7089 99.7714C83.3786 103.634 82.729 119.9 82.729 119.9C82.729 119.9 92.7819 125.961 104.483 127.352C111.938 128.237 119.441 126.194 125.733 122.099L161.679 98.7013C163.113 97.816 166.865 94.8877 166.962 92.008L167.224 63.8438C167.369 59.5048 165.498 57.5494 162.231 55.6329L68.7791 0.919351C66.7239 -0.30645 64.2616 -0.30645 62.2064 0.919351L8.09347 33.1988C5.95105 34.4635 4.62295 36.8956 4.63264 39.3861L0.134533 66.704C-1.51348 71.5877 12.5237 79.643 12.5237 79.643H12.5334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.12b62d1d5652652770e179aa3fd26662.svg";
export { ForwardRef as ReactComponent };